import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { SpecialZoomLevel } from '@react-pdf-viewer/core'

type StateType = {
  zoomLevel: SpecialZoomLevel | number
  isFileListOpen: boolean
  isMetadataViewerOpen: boolean
  isFirstRender: boolean
}

const initialState: StateType = {
  zoomLevel: SpecialZoomLevel.PageWidth,
  isFileListOpen: false,
  isMetadataViewerOpen: false,
  isFirstRender: true,
}

const documentViewerSlice = createSlice({
  name: 'fileManager',
  initialState,
  reducers: {
    setDocumentViewerState: (state, action: PayloadAction<StateType>) => {
      return { ...state, ...action.payload }
    },
    setZoomLevel: (state, action: PayloadAction<SpecialZoomLevel | number>) => {
      state.zoomLevel = action.payload
    },
    setIsFileListOpen: (state, action: PayloadAction<boolean>) => {
      state.isFileListOpen = action.payload
      state.isFirstRender = false
    },
    setIsMetadataViewerOpen: (state, action: PayloadAction<boolean>) => {
      state.isMetadataViewerOpen = action.payload
      state.isFirstRender = false
    },
  },
})

export const { setDocumentViewerState, setZoomLevel, setIsFileListOpen, setIsMetadataViewerOpen } =
  documentViewerSlice.actions

export const documentViewerReducer = documentViewerSlice.reducer
